module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/globe-stand.svg?13a526329d7594d883abbc6264bd0ed5";